import gql from 'graphql-tag'

export const CREATE_UPDATE_VEHICLE = gql`
mutation ($vehicles:[Vehicles_insert_input!]!, $vehicle_on_conflict_rule: Vehicles_on_conflict!) {
  insert_Vehicles(objects: $vehicles, on_conflict: $vehicle_on_conflict_rule){
    returning{
      id
    }
  }  
}`
